module.exports = __webpack_public_path__ + "img/9-11_conacin_franco_cabello_thumb.f17aff80.jpg";